var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asset-tabs-component"},[_vm._l((_vm.tabs),function(tab){return [_c('div',{key:tab.key,class:['item',_vm.active === tab.key?'active':''],on:{"click":function($event){return _vm.gotoPage(tab)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }